import type { City, Country, Location, Province } from '@interfaces/location.interface';

import {
  CITY_DATA,
  COUNTRY_DATA,
  LOCATION_NAMES,
  PROVINCE_DATA,
  STREET_NAMES,
  ZIP_CODES,
} from '../pools';
import { isoNow, pick, randomFloat, uuid } from '../utils';

export function buildCountries(): Country[] {
  return COUNTRY_DATA.map(c => ({ id: c.id, name: c.name }));
}

export function buildProvinces(): Province[] {
  return PROVINCE_DATA.map(p => ({ id: p.id, name: p.name }));
}

export function buildCities(): City[] {
  return CITY_DATA.map(c => ({
    id: c.id,
    municipalityCode: c.municipalityCode,
    name: c.name,
    provinceCode: c.provinceCode,
  }));
}

export function buildLocation(overrides?: Partial<Location>): Location {
  const city = pick(CITY_DATA);
  const now = isoNow();
  return {
    id: uuid(),
    name: pick(LOCATION_NAMES),
    address: `${pick(STREET_NAMES)} ${Math.floor(Math.random() * 100) + 1}`,
    city: city.name,
    province: PROVINCE_DATA.find(p => p.id === city.provinceCode)?.name,
    country: 'Spain',
    zipCode: pick(ZIP_CODES),
    coordinates: {
      latitude: randomFloat(36.0, 43.5, 6),
      longitude: randomFloat(-8.0, 3.3, 6),
    },
    createdAt: now,
    updatedAt: now,
    ...overrides,
  };
}

export function buildLocations(count: number): Location[] {
  return Array.from({ length: count }, () => buildLocation());
}
